class CookiesForm extends Component {

    /** @type HTMLElement */
    default;

    /** @type HTMLFormElement */
    form;

    /**
     * @param {HTMLElement} el
     */
    constructor(el) {
        super(el);
        this.default = el.querySelector('[data-default]');
        el.querySelectorAll('[data-control]').forEach(el => el.addEventListener('click', e => this.cookiesSwitch(e)));
        this.toggles = el.querySelectorAll('input[type=checkbox]');
        this.form = el.querySelector('form');
        this.form.addEventListener('submit', e => this.onFormSubmitted(e));
    }

    /**
     * @param {MouseEvent} e
     */
    cookiesSwitch(e) {
        e.preventDefault();
        const toggle = Number.parseInt(e.currentTarget.dataset.toggle);
        this.toggles.forEach(el => el.checked = toggle === 1);
        this.onSubmitted();
        fetch(e.currentTarget.getAttribute('href')).then(() => this.onConsentStored()).catch(error => console.error('error:', error));
    }

    onFormSubmitted(e) {
        const data = new FormData(this.form);
        const params = new URLSearchParams();
        data.forEach((e, i) => params.append(i, e.toString()));
        const url = this.form.action + "?" + params.toString();
        this.onSubmitted();
        fetch(url).then(() => this.onConsentStored()).catch(error => console.error('error:', error));
        e.preventDefault();
    }

    onSubmitted() {
        EventBus.getInstance().dispatchEvent('showGlobalSpinner');
    }

    onConsentStored() {
        EventBus.getInstance().dispatchEvent('hideGlobalSpinner');
        location.reload();
    }

}
